import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, Empregador, PortalServidorBatidas, ResultadoGeracaoAcessos, StatusSolicitacao, TipoDocumentoOficial } from '../../api.service';
import { ServicoFormatacao } from '../../shared/servico-formatacao';

@Injectable({ providedIn: 'root' })
export class ServicoPortalServidor {
  constructor(
    private readonly api: ApiService,
    private readonly servicoFormatacao: ServicoFormatacao
  ) {}

  buscarTenant() {
    return this.api.buscarTenantPublico();
  }

  iniciais(nome?: string) {
    const partes = (nome || 'Ponto JWM').trim().split(/\s+/).filter(Boolean);
    return ((partes[0]?.[0] || 'P') + (partes[1]?.[0] || 'J')).toUpperCase();
  }

  logo(tenant?: Empregador) {
    if (!tenant?.logoBase64) {
      return '';
    }
    return tenant.logoBase64.startsWith('data:')
      ? tenant.logoBase64
      : `data:${tenant.logoMimeType || 'image/png'};base64,${tenant.logoBase64}`;
  }

  mascararCpfDigitado(valor: string) {
    return this.servicoFormatacao.formatarCpf(valor);
  }

  cpfParaLogin(valor: string) {
    return this.servicoFormatacao.apenasNumeros(valor);
  }

  colunasBatida(dias: PortalServidorBatidas['dias']) {
    const maximo = Math.max(
      4,
      ...dias.flatMap(dia => dia.batidas.map(batida => batida.numeroBatida || 0))
    );
    return Array.from({ length: maximo }, (_, indice) => indice + 1);
  }

  batidaNaColuna(dia: PortalServidorBatidas['dias'][number], coluna: number) {
    const comNumero = dia.batidas.find(batida => batida.numeroBatida === coluna);
    if (comNumero) {
      return comNumero;
    }
    const semNumero = dia.batidas.filter(batida => !batida.numeroBatida);
    return semNumero[coluna - 1];
  }

  mensagemAcessos(resultado: ResultadoGeracaoAcessos) {
    return `Acessos gerados: ${resultado.criados} criados, ${resultado.jaExistiam} ja existiam, ${resultado.ignorados} ignorados. Login = CPF. Senha inicial = 6 primeiros digitos do CPF.`;
  }

  buscarBatidas() {
    return this.api.buscarBatidasServidor();
  }

  baixarComprovante(nsr: number) {
    return this.api.baixarComprovanteServidor(nsr);
  }

  alterarSenha(senhaAtual: string, senhaNova: string): Observable<void> {
    return this.api.alterarSenhaServidor(senhaAtual, senhaNova);
  }

  listarAjustes() {
    return this.api.listarAjustesServidor();
  }

  pedirAjuste(data: string, numeroBatida: number, hora: string, motivo: string) {
    return this.api.pedirAjusteServidor(data, numeroBatida, hora, motivo);
  }

  listarFerias() {
    return this.api.listarFeriasServidor();
  }

  pedirFerias(dataInicio: string, dataFim: string) {
    return this.api.pedirFeriasServidor(dataInicio, dataFim);
  }

  listarDocumentos() {
    return this.api.listarDocumentosServidor();
  }

  pedirDocumento(tipo: TipoDocumentoOficial, finalidade: string) {
    return this.api.pedirDocumentoServidor(tipo, finalidade);
  }

  rotuloStatus(status?: StatusSolicitacao) {
    if (status === 'DEFERIDA') {
      return 'Deferida';
    }
    if (status === 'INDEFERIDA') {
      return 'Indeferida';
    }
    return 'Pendente';
  }

  formatarData(valor?: string) {
    return this.servicoFormatacao.formatarDataIso(valor);
  }

  dataIsoHoje() {
    const hoje = new Date();
    const mes = String(hoje.getMonth() + 1).padStart(2, '0');
    const dia = String(hoje.getDate()).padStart(2, '0');
    return `${hoje.getFullYear()}-${mes}-${dia}`;
  }
}
